import React from 'react'
import styles from "./styles.module.css"
import { Link } from 'react-router-dom'

const MenuBar = ({ menu = [] }) => {
    return (
        <div className={styles.menubar}>
            {
                menu.map((item, i) => (
                    <Link to={item.url} className={`${styles.menu} ${item.active && styles.active}`} key={i}>{item.name}</Link>
                ))
            }


        </div>
    )
}

export default MenuBar